/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import get from 'lodash/get';

const defaultSeoMeta = {};
export const selectIrisData = (state) => state.irisData;
export const selectCriteoZone = (state) => state.criteoZone;

export const selectIrisSeoMeta = createSelector(selectIrisData, (irisData) =>
    get(irisData, 'seoMetaData', defaultSeoMeta)
);

export const selectCriteoProducts = createSelector(selectCriteoZone, (criteoZone) =>
    get(criteoZone, 'criteoProducts', [])
);

export const selectOnLoadBeacon = createSelector(selectCriteoZone, (criteoZone) =>
    get(criteoZone, 'onLoadBeacon', null)
);
